import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";


const extractSearchParams = (searchParams: URLSearchParams) => {
    const newState: any = {};
    searchParams.forEach((value, key) => {
        if (!newState[key]) {
            newState[key] = value;
        } else {
            if (!Array.isArray(newState[key])) {
                newState[key] = [newState[key]];
            }
            newState[key].push(value);
        }
    });
    return newState;
};

const removeObjectEmptyKeyValues = (obj: Record<string, any>) => {
    return Object.entries(obj).reduce((accumulator: Record<string, any>, [key, value]) => {
        if (value !== null && value !== "null" && value !== "" && value !== undefined) {
            accumulator[key] = value
        }
        return accumulator
    }
        , {});
}


const useUrlState = (defaultState: any = {}, filterBlank = false) => {
    const [searchParams, setSearchParams] = useSearchParams(
        filterBlank ? removeObjectEmptyKeyValues(defaultState) : defaultState
    );
    const setParams = (params: URLSearchParams) => {
        filterBlank ? setSearchParams(removeObjectEmptyKeyValues(params)) : setSearchParams(params);
    };
    const state = useMemo(() => extractSearchParams(searchParams), [searchParams]);
    return [state, setParams];
};

export default useUrlState;
